import { Default_Image, base64Image } from '@/constants';
import { IProductDetails } from '@/interfaces/product';
import { getYoutubeIdFromUrl } from '@/utils/helper';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Magnifier from 'react-magnifier';
const ReactPlayer = dynamic(() => import('react-player/youtube'), { ssr: false });

const ProductDetailImage = ({
  quickView,
  productDetail,
  config = { slidesPerView: 'auto', spaceBetween: 4 },
}: {
  quickView?: boolean;
  productDetail?: IProductDetails;
  config?: any;
}) => {
  const [productImage, setProductImage] = useState(productDetail?.ProductImageList?.[0]);
  //  const [url, setUrl] = useState('');
  const [mounted, mount] = useState(false);
  const [videoAspectRatio, setVideoAspectRatio] = useState('');
  const [poster, showPoster] = useState(true);

  useEffect(() => {
    setProductImage(productDetail?.ProductImageList?.[0]);
    mount(true);
    //setUrl(productDetail?.ProductImageList?.find((x) => x.IsVideo)?.Url);
    return () => {
      console.log('destroying');
      mount(false);
      // setUrl('');
    };
  }, [productDetail]);
  const url = productDetail?.ProductImageList?.find((x) => x.IsVideo)?.Url;
  const youtubeId = getYoutubeIdFromUrl(url);
  const checkDimension = () => {
    if (typeof window != 'undefined') {
      if (url?.includes('iframe')) {
        var div = document.createElement('div');
        div.innerHTML = url.trim();
        const el = div.firstChild as HTMLIFrameElement;
        if (el) setVideoAspectRatio(el.width + '/' + el.height);
      } else {
        const el: HTMLElement = document.getElementsByClassName('product-video-container')[0] as HTMLElement;
        const el2 = el?.getElementsByTagName('iframe')[0];
        if (el2) setVideoAspectRatio(el2.width + '/' + el2.height);
      }
    }
  };
  return quickView ? (
    <>
      <div className="relative aspect-square">
        {productImage?.IsVideo === false && productImage?.Url ? (
          <Image
            className="object-contain"
            src={productImage?.Url}
            alt={productImage?.AltAttribute}
            fill
            quality={100}
            sizes="100%"
            placeholder="blur"
            blurDataURL={base64Image}
            unoptimized={true}
          />
        ) : (
          mounted &&
          url && (
            <>
              <ReactPlayer
                onReady={checkDimension}
                url={url}
                muted={true}
                loop={true}
                playing={true}
                onPause={() => showPoster(true)}
                height="100%"
                className="product-video-container"
                width="100%"
                onPlay={() =>
                  setTimeout(() => {
                    showPoster(false);
                  }, 3000)
                }
                config={{
                  playerVars: { showinfo: 0, disablekb: 0 },
                }}
              />
              <Image
                src={youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : Default_Image}
                alt="video"
                className={`h-full w-full transition-opacity duration-500 ${poster ? '' : 'opacity-0'}`}
                unoptimized={true}
                fill
                loading="eager"
                blurDataURL={base64Image}
                placeholder="blur"
                objectFit="cover"
              ></Image>
            </>
          )
        )}
      </div>

      <div className="mt-12 grid grid-cols-6 gap-4">
        {productDetail?.ProductImageList?.filter((x) => !x.IsSizeGuide).map((image, index: number) => (
          <div
            key={image.ProductId + '-' + index}
            className="relative aspect-square  border hover:cursor-pointer hover:border-black"
            onMouseEnter={() => {
              setProductImage(image);
            }}
          >
            {image?.IsVideo === false && image?.IsSizeGuide === false && image?.Url ? (
              <Image
                className="object-contain"
                src={image?.Url}
                alt={image?.AltAttribute}
                fill
                quality={100}
                sizes="100%"
                placeholder="blur"
                blurDataURL={base64Image}
                unoptimized={true}
              />
            ) : (
              url && (
                <Image
                  src={
                    getYoutubeIdFromUrl(image.Url) ? `https://img.youtube.com/vi/${getYoutubeIdFromUrl(image.Url)}/maxresdefault.jpg` : Default_Image
                  }
                  alt="video"
                  className={`h-full w-full transition-opacity duration-500`}
                  unoptimized={true}
                  fill
                  loading="eager"
                  blurDataURL={base64Image}
                  placeholder="blur"
                  objectFit="cover"
                ></Image>
              )
            )}
          </div>
        ))}
      </div>
    </>
  ) : (
    <>
      {productDetail?.IsGiftVoucher ? (
        <div className="flex grow items-start justify-center">
          <div className=" relative aspect-square w-[min(650px,100%)]">
            {productImage?.Url && (
              <Image
                className="object-contain"
                src={productImage?.Url}
                alt={productImage?.AltAttribute}
                fill
                quality={100}
                sizes="100%"
                placeholder="blur"
                blurDataURL={base64Image}
                unoptimized={true}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          {url && (
            <div
              className={`relative aspect-square w-full`}
              style={url?.includes('iframe') ? (videoAspectRatio ? { aspectRatio: videoAspectRatio } : { aspectRatio: '16/9' }) : {}}
            >
              {mounted && (
                <>
                  <ReactPlayer
                    onReady={checkDimension}
                    className="product-video-container"
                    url={url}
                    muted={true}
                    loop={true}
                    playing={true}
                    height="100%"
                    width="100%"
                    onPause={() => showPoster(true)}
                    onPlay={() =>
                      setTimeout(() => {
                        showPoster(false);
                      }, 3000)
                    }
                    config={{
                      playerVars: { showinfo: 0, disablekb: 0 },
                    }}
                  />
                  <Image
                    src={youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : Default_Image}
                    alt="video"
                    className={`h-full w-full transition-opacity duration-500 ${poster ? '' : 'opacity-0'}`}
                    unoptimized={true}
                    fill
                    loading="eager"
                    blurDataURL={base64Image}
                    placeholder="blur"
                    objectFit="cover"
                  ></Image>
                </>
              )}
            </div>
          )}
          <div className="-mx-1 ">
            <div className="mt-1 flex w-full flex-wrap">
              {productDetail?.ProductImageList?.filter((x) => !x.IsVideo && !x.IsSizeGuide).map((image: any, index: number) => (
                <div key={image.ProductId + '-' + index} className={`p-1 ${index < 2 ? 'w-1/2' : index < 5 ? 'w-1/3' : 'w-1/4'}`}>
                  {
                    // @ts-ignore
                    <Magnifier
                      mgWidth={350}
                      mgHeight={350}
                      src={image?.Url || ''}
                      // @ts-ignore
                      alt={image.AltAttribute}
                      zoomFactor={index > 1 ? 1.1 : 0.6}
                      mgShape="square"
                    />
                  }
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetailImage;
